export default {
    betaWarning: 'Αυτόματη δημιουργία διατροφικού πλάνου',
    days: 'Ποιες ημέρες θέλετε να παραχθούν; (Θα διαγραφούν τα περιεχόμενα αυτών των ημερών)',
    enableAll: 'Ενεργοποίηση όλων',
    disableAll: 'Απενεργοποίηση όλων',
    calories: 'Πόσες θερμίδες;',
    sameDinner: 'Ίδιο μεσημεριανό/βραδινό;',
    sameDinner2: 'επιλέγει πάντα το μεσημεριανό ως κατηγορία προτύπου',
    calorieDistribution: 'Πώς θέλετε να καταμεριθούν ποσοστιαία οι θερμίδες; (γράψτε 0 για να αγνοήσετε το γεύμα)',
    intro: '<p>\n' +
        '        Η αυτόματη δημιουργία διατροφικού πλάνου λειτουργεί με βάση τα δικά σας πρότυπα γεύματα. Για να έχετε καλύτερη\n' +
        '        εμπειρία χρήσης, θα χρειαστεί να φτιάξετε\n' +
        '        σωστά και ισορροπημένα πρότυπα ώστε το τελικό διαιτολόγιο να έχει σωστές συνθέσεις τόσο σε συνδυασμούς τροφίμων\n' +
        '        όσο και σε κατανομή μακροθρεπτικών συστατικών.\n' +
        '      </p>\n' +
        '      <p>\n' +
        '        Οι ποσότητες στρογγυλοποιούνται σε βήματα που μετριούνται εύκολα (π.χ. ανά 5 ή 10 γραμμάρια, ¼ φλιτζάνι,\n' +
        '        ½ κουταλιά). Αυγά, φέτες ψωμί και ό,τι μετριέται σε τεμάχια μένουν ακέραια όπου γίνεται, ενώ τα φρούτα μπορεί\n' +
        '        να μπουν και μισά. Λαχανικά και καρυκεύματα με λίγες θερμίδες συνήθως κρατούν την ποσότητα του προτύπου.\n' +
        '      </p>\n' +
        '      <p>\n' +
        '        Το σύστημα δημιουργήθηκε για να σας βοηθήσει να κάνετε γρηγορότερα τη δουλειά σας και όχι να σας αντικαταστήσει.\n' +
        '        <strong>Παρακαλούμε να δώσετε προσοχή στο διαιτολόγιο και τις επιλογές του πριν το δώσετε σε κάποιον\n' +
        '          διαιτώμενο.</strong>\n' +
        '\n' +
        '      </p>\n' +
        '      <p>\n' +
        '        <strong>Εάν δεν έχετε πρότυπα γεύματα, δεν μπορεί να λειτουργήσει η αυτόματη παραγωγή διαιτολογίων.</strong>\n' +
        '      </p>',
}